import { getBasket } from "~/store/basket/actions"
import {
  getBasketDomains,
  getBasket as getBasketSelector,
  getBasketToken,
} from "~/store/basket/selectors"
import type { BasketState } from "~/store/basket/types"
import { useAppDispatch, useAppSelector } from "~/store/hooks"

interface BasketHook {
  basket: BasketState
  basketDomains: string[]
  getBasket: { (): void }
}

export default function useBasket(): BasketHook {
  const token = useAppSelector(getBasketToken)

  const dispatch = useAppDispatch()

  const basket = useAppSelector(getBasketSelector)

  const basketDomains = useAppSelector(getBasketDomains)

  const getBasketDispatcher = () => {
    dispatch(getBasket(token))
  }

  return {
    basket,
    basketDomains,
    getBasket: getBasketDispatcher,
  }
}
